'use client'

import { ExternalLinkIcon, LinkIcon, OctagonAlert } from 'lucide-react'

import { SplitsLink as Link } from '~/components/Link'
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '~/components/component-library/Dropdown'
import { UpdateTransactionMemoDropdownItem } from '~/components/smart-accounts/UpdateTransactionMemoDropdownItem'
import { HideTokenDropdownItem } from '~/components/smart-accounts/utils'
import { useActiveOrgId } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'
import { useOrgSmartAccount } from '~/hooks/useSmartAccounts'
import { OrgAssetTransfer } from '~/types'
import { EvmAddress } from '~/utils/address'
import { getExplorerTransactionLinkChainId } from '~/utils/addresses'
import { copyToClipboard } from '~/utils/copyToClipboard'

export const TransferDropdownMenuItems = ({
  assetTransfer,
}: {
  assetTransfer: OrgAssetTransfer
}) => {
  const { user: authUser } = useAuthUser()
  const activeOrgId = useActiveOrgId()
  const { smartAccount } = useOrgSmartAccount(assetTransfer.smartAccountAddress)
  const hasAccess = !!authUser && smartAccount?.orgId === activeOrgId

  return (
    <>
      <DropdownMenuItem
        onClick={() => {
          const url = `${window.location.origin}/accounts/${assetTransfer.smartAccountAddress}/transactions/inbound/${assetTransfer.id}/`
          copyToClipboard(url, 'Link copied to clipboard')
        }}
      >
        <LinkIcon />
        <div>Copy link</div>
      </DropdownMenuItem>
      <Link
        path={getExplorerTransactionLinkChainId(
          assetTransfer.transactionHash,
          assetTransfer.chainId,
        )}
        target="tab"
      >
        <DropdownMenuItem>
          <ExternalLinkIcon />
          <div>Open in explorer</div>
        </DropdownMenuItem>
      </Link>
      {hasAccess && smartAccount && (
        <>
          <DropdownMenuSeparator />
          <UpdateTransactionMemoDropdownItem transaction={assetTransfer} />
          <DropdownMenuSeparator />
          <HideTokenDropdownItem
            smartAccountAddress={assetTransfer.smartAccountAddress}
            token={EvmAddress.format(assetTransfer.tokenAddress)}
            assetType={assetTransfer.assetType}
            nftSymbol={assetTransfer.nftSymbol}
            nftTokenId={assetTransfer.tokenId}
            chainId={assetTransfer.chainId}
          >
            <OctagonAlert />
            <div>Report spam...</div>
          </HideTokenDropdownItem>
        </>
      )}
    </>
  )
}
